import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import logo from '../logo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* LEFT SECTION */}
        <div className="footer-about">
          <img src={logo} alt="logo" className="footer-logo" />
          <p>
            A peaceful Christian retreat on Mutungo Hill, offering rest,
            reflection, and renewal overlooking Lake Victoria.
          </p>

          <div className="socials">
            <i className="fab fa-facebook-f"></i>
            <i className="fab fa-instagram"></i>
            <i className="fab fa-twitter"></i>
          </div>
        </div>

        {/* EXPLORE */}
        <div className="footer-links">
          <h3>EXPLORE</h3>
          <ul className="footul">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/accommodation">Accommodation</Link></li>
            <li><Link to="/dining">Dining & Bar</Link></li>
            <li><Link to="/events">Events</Link></li>
            <li><Link to="/retreats">Retreats</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
          </ul>
        </div>

        {/* ACCOMMODATION */}
        <div className="footer-links">
          <h3>ACCOMMODATION</h3>
          <ul className="footul">
            <li> <Link to="/rooms">Standard Room</Link></li>
            <li> <Link to="/rooms">Single Room</Link></li>
            <li> <Link to="/rooms">Double Room</Link></li>
            <li> <Link to="/rooms">Family Room</Link></li>
            <li> <Link to="/rooms">Deluxe Room</Link></li>
            <li> <Link to="/rooms">VIP Suite</Link></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h3>CONTACT</h3>
          <p>📞 +256 775 203734</p>
          <p>✉️ info@fathershouseuganda.com</p>
          <p>📍 Mutungo Hill, Lubowa Wakiso District, Uganda</p>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>© 2026 Father's House Church Resort. All rights reserved.</p>
        <div>
          <span>Privacy Policy</span>
          <span>Terms of Service</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;